import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ProjectInfo from '../detail/ProjectInfo';
import ProjectTeam from '../detail/team';
import ProjectBudget from '../detail/budget';
import ProjectSchedule from '../detail/schedule';
import ProjectDocuments from '../detail/documents';
import ProjectLocations from '../detail/locations';
import DelayLogs from '../detail/DelayLogs';
import ProgressReports from '../detail/ProgressReports';
import Pia from '../detail/Pia';
import Comments from '../detail/comments';
import BlueBook from '../detail/BlueBook';
import BidPackageNew from '../detail/BidPackageNew';
import FactSheet from '../detail/FactSheet';
import ContractorFieldInfo from '../detail/ContractorFieldInfo';
import CostModule from '../detail/CostModule';
import InfraChecklist from '../detail/InfraChecklist';
import AETracking from '../detail/AETracking';
import ClientAgencyInfo from '../detail/ClientAgencyInfo';
import RfsNew from '../detail/rfsNew';
import ProjectContractDetailsNew from '../detail/ProjectContractDetailsNew';
import ProjectPayments from '../detail/ProjectPayments';
import CPDetails from '../detail/CPDetails';
import NewBudget from '../detail/NewBudget';
import Modal from 'react-modal';
import { modalStyle } from '../../constants';
import FepDocumentsTable from '../detail/FepDocumentsTable';
import { SITE_SAFETY_URL_PROJECT } from '../../actions/index';
import ProjectApproval from '../detail/ProjectApproval';
import FactSheetInfra from '../detail/FactSheetInfra';

class Tabs extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            activeTabIndex: this.props.defaultActiveTabIndex,
            modalIsOpen: false,
            redirectedTabIndex: null
        };

        this.handleTabClick = this.handleTabClick.bind(this);
        this.renderModal = this.renderModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.stayOnPage = this.stayOnPage.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if ((this.props.defaultActiveTabIndex === 0 || this.props.defaultActiveTabIndex === null) && nextProps.defaultActiveTabIndex === 1) {
            this.setState({ activeTabIndex: 1 });
        }
    }

    hideNavBar() {
        var navIcons = document.getElementsByClassName('nav-icons-visibility'),
            i = navIcons.length;

        while (i--) {
            navIcons[i].style.visibility = 'hidden';
        }
    }

    showNavBar() {
        var navIcons = document.getElementsByClassName('nav-icons-visibility'),
            i = navIcons.length;

        while (i--)
            navIcons[i].style.visibility = 'visible';
    }

    closeModal() {
        this.setState({ modalIsOpen: false });
    }

    renderModal() {
        return (
            <Modal
                isOpen={this.state.modalIsOpen}
                style={modalStyle}
                contentLabel="Add"
            >
                <div className="member-form modal-form">
                    <h1>Warning</h1>

                    <div className="modal-close"
                        onClick={() => this.closeModal()}>
                        <span className="close"></span>
                    </div>

                    <p>Entered data is not saved, do you want to continue without saving?</p>

                    <div className="actions">
                        <button className="alert-save" onClick={() => this.stayOnPage()}>Yes</button>
                        <button className="alert-cancel" onClick={() => this.closeModal()}>No</button>
                    </div>

                </div>
            </Modal>
        )
    }

    stayOnPage() {
        this.setState({ activeTabIndex: this.state.redirectedTabIndex, modalIsOpen: false });
    }

    handleTabClick(tabIndex) {

        // to address scroll/refresh issue
        window.scrollTo(0, 0);

        this.setState({ activeTabIndex: tabIndex });

        // show/hide nav bar icons based on selected tab
        if (tabIndex !== 0 || this.props.subTb === true) {
            this.hideNavBar();
        }
        else {
            this.showNavBar();
        }
    }

    // Encapsulate <Tabs/> component API as props for <Tab/> children
    renderChildrenWithTabsApiAsProps() {
        return React.Children.map(this.props.children, (child, index) => {
            return React.cloneElement(child, {
                onClick: this.handleTabClick,
                tabIndex: index,
                isActive: index === this.state.activeTabIndex,
                subTb: this.props.subTb
            });
        });
    }

    // Render current active tab content 
    renderActiveTabContent() {
        const { children } = this.props;
        const { activeTabIndex } = this.state;

        if (children[activeTabIndex]) {
            return children[activeTabIndex].props.children;
        }
    }

    render() {

        let tabsClass, ulClass = '';
        if (this.props.className === 'subtabs-custom') {
            tabsClass = 'subtabs-custom';
            ulClass = 'subtabs-custom-nav nav navbar-nav navbar-left no-print';
        }
        else {
            tabsClass = 'tabs-custom';
            ulClass = 'tabs-custom-nav nav navbar-nav navbar-left no-print';
        }

        return (
            <div className={tabsClass}>

                {this.renderModal()}

                <ul className={ulClass}>
                    {this.renderChildrenWithTabsApiAsProps()}
                </ul>
                <div className="tabs-custom-active-content">
                    {this.renderActiveTabContent()}
                </div>
            </div>
        );
    }
}

Tabs.defaultProps = {
    defaultActiveTabIndex: 0
};

Tabs.propTypes = {
    defaultActiveTabIndex: PropTypes.number
};

class Tab extends Component {

    constructor(props, context) {
        super(props, context);
        this.handleTabClick = this.handleTabClick.bind(this);
    }

    handleTabClick(event) {
        event.preventDefault();
        this.props.onClick(this.props.tabIndex);
    }

    render() {
        const tabName = this.props.tabName;
        let subTabLinkClass = '';
        const tabId = this.props.tabId;

        if (this.props.className === 'subtab-custom') {
            subTabLinkClass = 'subtab-custom-link';
        }
        else {
            subTabLinkClass = 'tab-custom-link';
        }

        return (
            <li className="tab-custom" id={tabId}>
                <a className={`${subTabLinkClass} ${this.props.linkClassName} ${this.props.isActive ? 'active' : ''}`}
                    onClick={this.handleTabClick}>
                    {tabName}
                    <i className={`tab-custom-icon ${this.props.iconClassName}`} />
                </a>
            </li>
        );
    }
}

Tab.propTypes = {
    onClick: PropTypes.func,
    tabIndex: PropTypes.number,
    isActive: PropTypes.bool,
    iconClassName: PropTypes.string.isRequired,
    linkClassName: PropTypes.string.isRequired
};

class TabsComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {
        const { permissions, projectId, divisionName, currentTabIndex } = this.props;
        const projectProps = { projectId, permissions, currentTabIndex };

        var linkToSs = SITE_SAFETY_URL_PROJECT + this.props.projectId;

        let tabId = '';
        if (divisionName === 'Infrastructure')
            tabId = 'displayNone';
        else
            tabId = '';

        const { roleModules } = permissions.editPrivileges;

        var hasPiaRole = false;
        if (roleModules) {
            hasPiaRole = roleModules.includes('PIA')
        }

        return (
            <Tabs defaultActiveTabIndex={currentTabIndex}>
                <Tab iconClassName={'icon-class-0'}
                    linkClassName={'custom-link'}
                    tabIndex={0}
                    tabName={'Project Info'}>
                    <ProjectInfo {...projectProps} />
                    <ClientAgencyInfo {...projectProps} />
                    <ContractorFieldInfo {...projectProps} />
                    <ProjectTeam {...projectProps} />
                    <ProjectSchedule {...projectProps} />
                    <ProjectBudget projectId={projectId} />
                    <ProjectDocuments {...projectProps} />
                    <ProjectLocations projectId={projectId} />
                    <DelayLogs {...projectProps} />
                    <ProgressReports {...projectProps} />
                    <Comments {...projectProps} />
                    {hasPiaRole ?
                        <Pia {...projectProps} /> : null}
                    <ProjectApproval {...projectProps} />
                </Tab>
                <Tab iconClassName={'icon-class-1'}
                    linkClassName={'custom-link'}
                    tabIndex={2}
                    tabName={'A&E Bid Package'}
                    tabId={tabId}>
                    <BidPackageNew {...projectProps} />
                </Tab>
                <Tab iconClassName={'icon-class-1'}
                    linkClassName={'custom-link'}
                    tabIndex={3}
                    tabName={'Blue Book'}
                    tabId={tabId}>
                    <BlueBook {...projectProps} />
                </Tab>
                <Tab iconClassName={'icon-class-1'}
                    linkClassName={'custom-link'}
                    tabIndex={4}
                    tabName={'Fact Sheet'}
                >
                    {divisionName === 'Infrastructure' ? <FactSheetInfra {...projectProps} /> :
                        <FactSheet {...projectProps} />}
                </Tab>
                <Tab iconClassName={'icon-class-1'}
                    linkClassName={'custom-link'}
                    tabIndex={5}
                    tabId={tabId}
                    tabName={'Cost Module'}>
                    <CostModule {...projectProps} />
                </Tab>
                <Tab iconClassName={'icon-class-1'}
                    linkClassName={'custom-link'}
                    tabIndex={13}
                    tabName={'Contract Details'} >
                    <ProjectContractDetailsNew {...projectProps} />
                </Tab>

                <Tab iconClassName={'icon-class-1'}
                    linkClassName={'custom-link'}
                    tabIndex={6}
                    tabName={'Request For Services'}
                    tabId={tabId}>
                    <RfsNew {...projectProps} />
                </Tab>
                {divisionName === 'Infrastructure'
                    ? <Tab iconClassName={'icon-class-1'}
                        linkClassName={'custom-link'}
                        tabIndex={9}
                        tabName={'Milestones'}>
                        <InfraChecklist {...projectProps} />
                    </Tab>
                    : <Tab iconClassName={'icon-class-0'}
                        linkClassName={'custom-link'}
                        tabIndex={7}
                        tabName={'A&E Tracking'}>
                        <AETracking {...projectProps} sendData={this.getData} />
                    </Tab>}

                <Tab iconClassName={'icon-class-1'}
                    linkClassName={'custom-link'}
                    tabIndex={12}
                    tabName={'Payments'} >
                    <ProjectPayments {...projectProps} />
                </Tab>

                <Tab iconClassName={'icon-class-1'}
                    linkClassName={'custom-link'}
                    tabIndex={8}
                    tabName={'Budget'} >

                    <div className="container bg-white budget">
                        <Tabs className="subtabs-custom" subTb={true}>
                            <Tab iconClassName={'icon-class-1'}
                                linkClassName={'custom-link'}
                                tabIndex={10}
                                tabName={'CP Information'}
                                className="subtab-custom">
                                <CPDetails {...projectProps} />
                            </Tab>
                            <Tab iconClassName={'icon-class-1'}
                                linkClassName={'custom-link'}
                                tabIndex={11}
                                tabName={'Budget Details'}
                                className="subtab-custom">
                                <NewBudget {...projectProps} />
                            </Tab>
                        </Tabs>
                    </div>

                </Tab>

                <Tab iconClassName={'icon-class-1'}
                    linkClassName={'custom-link'}
                    tabIndex={14}
                    tabName={'FEP Documents'} >
                    <FepDocumentsTable {...projectProps} />
                </Tab>

                <li className="tab-custom">
                    <a className="tab-custom-link custom-link" href={linkToSs}
                        target='_self'>
                        Safety Plans
                    </a>
                </li>

            </Tabs>
        );
    }
}

TabsComponent.propTypes = {
    projectId: PropTypes.string.isRequired,
    permissions: PropTypes.object.isRequired,
    divisionName: PropTypes.string.isRequired,
    currentTabIndex: PropTypes.number.isRequired
};

export { TabsComponent, Tabs, Tab };